export const TRANSLATIONS_HI = {
  deliver: 'वितरण',
  myOrders: 'मेरे आर्डर',
  update: 'अपडेट',
  required: 'रिक्वायर्ड',
  products: 'उत्पाद',
  unitsAvailable: 'यूनिट्स उपलब्ध',
  buy: 'खरीद',
  sell: 'बेचा',
  sellTo: 'बेचे',
  no: 'नही',
  notFound: 'नहीं मिला',
  withThisMobileNumber: 'इस मोबाइल नंबर के साथ',
  foundWithMobile: 'मोबाइल नंबर के साथ मिला',
  notFoundWithMobile: 'इस मोबाइल नंबर से कोई नहीं मिला',
  addNew: 'नया जोड़े',
  addNewRetailer: 'नया रिटेलर जोड़े',
  retailer: 'रिटेलर',
  addNewMason: 'नया शिल्पकार जोड़े',
  addNewProject: 'नया प्रोजेक्ट जोड़ें',
  upload: 'अपलोड',
  photo: 'फोटो',
  idProof: 'आईडी प्रूफ',
  registerSell: 'रजिस्टर करे और बेचे',
  registeremployee: 'रजिस्टर करे',
  address: 'पता',
  somethingWentWrong: 'कुछ गलत हो गया',
  submit: 'जमा',
  quantity: 'मात्रा',
  brand: 'ब्रांड',
  buyer: 'खरीदार',
  number: 'नंबर',
  company: 'कंपनी',
  companies: 'कंपनियां',
  available: 'उपलब्ध',
  next: 'अगला',
  prev: 'पिछला',
  somewrong: 'सर्वर बंद हे',
  noCompanySelected: 'कंपनी सेलेक्ट करो',
  noProductSelected: 'उत्पाद सेलेक्ट करो',
  noIdProof: 'फोटो आईडी प्रूफ दो',
  noPhotoError: 'फोटो चाहिए',
  maxQuantityExceed: 'मात्रा इससे ज्यादा नहीं',
  passwordNotMatch: 'पासवर्ड मैच नहीं हुआ',
  acceptTerms: 'कृपया नियम और शर्तें स्वीकार करें',
  noInvoiceFileFound: 'इनवॉइस फाइल नहीं मिली',
  retailerChoosenMultiple: 'रिटेलर कई बार सेलेक्ट किया हे',
  success: 'सफलतापूर्वक हो गया',
  otpSent: 'औ टी पी भेज दिया हे',
  sellInvoiceDone: 'सेल इनवॉइस सफलतापूर्वक बन गयी हे',
  pincode: 'पिन कोड',
  annualSales: 'वार्षिक बिक्री',
  monthlySales: 'इस महीने की बिक्री',
  otp: 'ओटीपी',
  otpRequired: 'ओटीपी आवश्यक',
  sendToRetailer: 'रिटेलर को भेजें',
  termsAndConditionsApplied: 'नियम और शर्तें लागू',
  gift: 'उपहार',
  sellInvoices: 'चालान बेचें',
  humbeeBenefits: 'हम्बी लाभ',
  enterLanguage: 'भाषा दर्ज करें',
  enterDisease: 'रोग दर्ज करें',
  name: 'नाम',
  firmEmail: 'फर्म ईमेल',
  date: 'दिनांक',
  total: 'कुल',
  baseproduct: 'आधार उत्पाद',
  todayprice: 'आज की कीमत',
  profiler: {
    addPersonalPanNo: 'व्यक्तिगत पैन नंबर जोड़ें।',
    profiler: 'प्रोफाइलर',
    businessProfiler: 'व्यापार प्रोफाइलर',
    personalProfiler: 'तुम्हें बेह्तर जानहूं',
    firmName: 'फर्म का नाम',
    firmType: 'फर्म प्रकार',
    propertiorName: 'मालिक/साथी/निर्देशक का नाम',
    cementVolume: 'सीमेंट की मात्रा',
    otherAncillary: 'अन्य व्यापार',
    qualification: 'योग्यता',
    enterQualification: 'योग्यता दर्ज करें',
    prefferedLanguage: 'पसंदीदा भाषा',
    marriageAnniversary: 'विवाह की वर्षगांठ',
    doYouHaveAnyHealthConsern: 'क्या आपके पास कोई स्वास्थ्य सहमति है',
    facebookId: 'फेसबुक आईडी',
    whatsappNo: 'व्हाट्सएप नंबर',
    dateOfBirth: 'जन्म की तारीख',
    food: 'पसंदीदा खाने',
    drinks: 'पीने का शौक',
    postRetirement: 'सेवानिवृत्ति के बाद',
    presentlyParticipating: 'वर्तमान में भाग ले रहे हैं',
    familyDetails: 'पारिवारिक विवरण',
    destinationsVisited: 'स्थलों का दौरा किया',
    doYouSeeYourNextGenerationParticipatingInYourBusiness:
      'क्या आप अपनी अगली पीढ़ी को अपने व्यवसाय में भाग लेते हुए देखते हैं?',
    timeFromApprox: 'लगभग से समय',
    yourManagerName: 'आपके प्रबंधक का नाम',
    gender: 'लिंग',
    phoneNo: 'फ़ोन नंबर',
    noOfShilpkar: 'नो. ऑफ़ शिल्प्कार',
    noOfRetailer: 'नो. ऑफ़ खुदरा',
    yearlyTurnOver: 'वार्षिक कारोबार',
    managerDetails: 'प्रबंधक',
    maritialStatus: 'वैवाहिक स्थिति',
  },
  gifts: {
    rewards: 'पुरस्कार',
    type: 'प्रकार',
    giftDeatils: 'उपहार विवरण',
    beneficiarysName: 'लाभार्थी का नाम',
    productName: 'प्रोडक्ट का नाम',
    status: 'दर्जा',
    updateStatus: 'नवीनतम स्थिति',
    redeemAndUpdateStatus: 'रिडीम करें और स्थिति अपडेट करें',
    pleaseUploadImagesOfGift: 'कृपया उपहार की छवियां अपलोड करें',
    myRetailersGiftTransactions: 'मेरे खुदरा विक्रेता उपहार लेनदेन',
    retailerName: 'खुदरा विक्रेता का नाम',
    masonName: 'मेसन नाम',
    giftName: 'उपहार का नाम',
  },
  login: {
    warning: 'वार्निंग',
    benefitsNotAvailableInYourAreaButStillYouCanContinue:
      'लाभ आपके क्षेत्र में उपलब्ध नहीं है लेकिन फिर भी आप जारी रख सकते हैं',
    userDoesntExists: 'उपयोगकर्ता मौजूद नहीं है',
    doYouWantToRegisterNow: 'क्या आप अभी रजिस्टर करना चाहते हैं?',
    welcome: 'स्वागत',
    username: 'मोबाइल नंबर',
    searchMobile: 'मोबाइल नंबर खोजें',
    password: 'पासवर्ड',
    usernamePlaceholder: 'पंजीकृत मोबाइल नंबर',
    usernamePlaceholderNew: 'नया पंजीकृत मोबाइल नंबर',
    signIn: 'साइन इन करें',
    forgotPassword: 'पासवर्ड भूल गए?',
    noAccount: 'खाता नहीं है?',
    newUserRegisterNow: 'नया यूज़र रजिस्टर करें',
    noUsername: 'कृपया अपना मोबाइल नंबर नाम दर्ज करें!',
    noPassword: 'कृपया अपना पासवर्ड दर्ज करें!',
    recovery: 'रिकवरी करे',
    loginUsing: 'लॉग इन उपयोग करते हुए',
    resendAfter: 'फिर से भेजें',
  },
  benefits: {
    Aggregation: 'सम्पूर्ण क्वांटिटी के आधार पर लाभ',
    LifeInsurance: 'जीवन बीमा',
    MedicalInsurance: 'स्वास्थ्य बीमा',
    GoldenAgePlan: 'गोल्डन एज प्लान',
    Tours: 'आकर्षक वार्षिक टूर',
  },
  register: {
    newUser: 'नए उपयोगकर्ता',
    registerHere: 'यहां रजिस्टर करें',
    email: 'ईमेल',
    emailPlaceholder: 'अपना पंजीकृत ईमेल दर्ज करें',
    mobileNo: 'मोबाइल नंबर ',
    createPassword: 'पासवर्ड बनाएं',
    confirmPassword: 'पासवर्ड की पुष्टि कीजिये',
    passwordAgain: 'पासवर्ड फिर से टाइप करें',
    mobilePlease: 'मोबाइल नंबर इनपुट करे',
    signUp: 'साइन अप करें',
    alreadyHaveAccount: 'पहले से ही एक खाता है!',
    signIn: 'साइन इन करें',
    noMobileNo: 'कृपया अपना मोबाइल नंबर दर्ज करें!',
    noEmail: 'कृपया अपना ईमेल इनपुट करें!',
    noPassword: 'कृपया अपना पासवर्ड दर्ज करें!',
    noConfirmPassword: 'कृपया अपना पुष्टिकरण पासवर्ड दर्ज करें!',
    passwordLengthError: 'पासवर्ड कम से कम 8 अंकों का हो',
  },
  verify: {
    sent: 'भेजा',
    send: 'भेजा',
    otp: 'ओटीपी',
    title: 'ओटीपी के साथ सत्यापित करें',
    otpOn: 'हमने इस पर एक ओटीपी भेजा है',
    registeredEmail: 'और आपका पंजीकृत ईमेल पता',
    codeNotReceived: 'मुझे कोई कोड नहीं मिला।',
    resend: 'पुन: भेजें',
    itOr: 'यह या',
    details: 'विवरण',
    changeRegistrationDetails: 'पंजीकरण विवरण बदलें',
    verify: 'सत्यापित करें',
    resetPassword: 'पासवर्ड रीसेट',
    oneTimePassword: 'एक बारी पासवर्ड',
    otpForOldNumber: 'पुराने फोन नंबर के लिए ओटीपी',
    otpForNewNumber: 'नए फोन नंबर के लिए ओटीपी',
  },
  onboarding: {
    editingShilpkar: 'शिल्पकार विक्रेता का संपादन',
    wrongGstNumber: 'गलत जीएसटी नंबर',
    nowUAre: 'आप कर रहे हैं',
    onboarding: 'ओनबोर्डिंग',
    firstName: 'पहला नाम',
    noName: 'कृपया अपना पहला नाम दर्ज करें',
    lastName: 'अंतिम नाम',
    noLastName: 'कृपया अपना अंतिम नाम दर्ज करें',
    companyName: 'कंपनी का नाम',
    firmName: 'फर्म का नाम',
    yourCompanyName: 'आपका कंपनी का नाम',
    noCompanyName: 'कृपया अपनी कंपनी का नाम दर्ज करें',
    registeredAs: 'के रूप में पंजीकृत',
    noRegisteredAs: 'कृपया चुनें कि आप कैसे पंजीकृत हैं',
    distibutor: 'वितरक',
    gstNo: 'जीएसटी संख्या',
    noGstNo: 'कृपया अपना जीएसटी नंबर दर्ज करें।',
    pleaseGstDetails: 'कृपया जीएसटी विवरण दें',
    panNo: 'पैन नंबर',
    noPanNo: 'कृपया अपना पैन नंबर दर्ज करें।',
    pleasePanDetails: 'कृपया पैन विवरण दें',
    companyPhoneNo: 'कंपनी फोन नंबर',
    noCompanyPhoneNo: 'कृपया अपनी कंपनी का फोन नं.',
    companySupportNumber: 'कंपनी सहायता संख्या',
    companyAddress: 'दुकान का पता',
    state: 'राज्य',
    city: 'शहर',
    district: 'ज़िला',
    streetAddress1: 'सड़क पता (लाइन 1',
    streetAddress2: 'गली का पता पंक्ति 2',
    postalCode: 'डाक कोड',
    verify: 'सत्यापित करें',
    accept: 'मैंने पढ़ लिया है और स्वीकार कर लिया है',
    acceptRetailer: 'खुदरा विक्रेता ने पढ़ लिया है और स्वीकार कर लिया है',
    conditions: 'करें',
    terms: 'मैंने सभी टर्म्स एक्सेप्ट कर ली हैं',
    uploadPhoto: 'फोटो अपलोड करे',
    uploadId: 'आईडी अपलोड करे',
    registeredCementCompanies: 'पंजीकृत सीमेंट कंपनियां',
    pleaseSelectRegisteredCementCompanies:
      'कृपया जिन सीमेंट कम्पनीयों के डीलर है वह चुने',
    retailerFirmName: 'रिटेलर फर्म का नाम',
    "Mason's": 'शिल्पकार का',
    "Retailer's": 'रिटेलर का',
    "Project's": 'परियोजना का',
    otpSentToRetailer: 'रिटेलर को एक टोकन भेजा गया है',
    retailerSell:
      'रिटेलर के खाते में स्टॉक दर्ज करने के लिए उस रिटेलर पर क्लिक करें',
    masonSell:
      'शिल्पकार के खाते में स्टॉक दर्ज करने के लिए उस शिल्पकार पर क्लिक करें',
    projectSell: 'प्रोजेक्ट को बेचने के लिए एग्जिट प्रोजेक्ट पर क्लिक करें',
    associateSell: 'सेल टू एसोसिएट के लिए एग्जिटिंग एसोसिएट पर क्लिक करें',
  },
  distributor: {
    distributor: 'डिस्ट्रीब्यूटर',
    project: 'परियोजना',
    associate: 'संबंद्ध करना',
    hello: 'नमस्ते',
    sellTo: 'सेल',
    mason: 'शिल्पकार',
    retailer: 'रिटेलर',
    dealer_reatiler: 'डीलर + रिटेलर',
    myInventory: 'मेरी इन्वेंटरी',
    add: 'जोड़ें',
    viewAllInventory: 'सभी इन्वेंटरी देखें',
    home: 'होम',
    stock: 'स्टॉक',
    invoices: 'इनवॉइस',
    settings: 'सेटिंग्स',
    orders: 'ऑर्डर्स',
    masonOnboaded: 'मेसन ऑनबोर्डेड',
  },
  benefitscertificates: {
    certificates: 'बीमा प्रमाणपत्र',
    certificate: 'सर्टिफिकेट टाइप',
    certificateName: 'प्रमाण - पत्र नाम',
    certificateDownload: 'गतिविधि',
    downloadcrtificate: 'प्रमाणपत्र डाउनलोड करें',
  },
  addInvoice: {
    quantityType: 'मात्रा प्रकार',
    noQuantityTypeChoosen: 'कोई मात्रा प्रकार नहीं चुना गया',
    youCanAddCompanyInProfileCompanyDealership:
      'आप कंपनी को प्रोफ़ाइल कंपनी डीलरशिप में जोड़ सकते हैं',
    addInvoice: 'इनवॉइस जोड़ें',
    productAdded: 'उत्पाद जोड़ा गया',
    productsAdded: 'उत्पाद जोड़े गए',
    companyName: 'कंपनी का नाम',
    searchProduct: 'उत्पाद खोजें',
    quantity: 'मात्रा',
    priceInInr: 'यूनिट मूल्य (INR)',
    addItem: 'सामान जोडें',
    editItem: 'संपादित आइटम',
    itemsAdded: 'आइटम जोड़े गए',
    continue: 'जारी रखना',
    searchCompany: 'कंपनी खोजें',
    details: 'इनवॉइस डिटेल्स',
    number: 'इनवॉइस नंबर',
    num: 'इनवॉइस नं',
    date: 'इनवॉइस तारीख',
    sellingdate: 'सेल तारीख',
    uploadFile: 'अपलोड फाइल',
    totalAmount: 'कुल अमाउंट',
    invoices: 'इनवॉइस',
    purchaseInvoice: 'खरीद चालान',
    verified: 'सत्यापित',
    pending: 'लंबित',
    rejected: 'अस्वीकार',
    noProductsWereAdded: 'कोई उत्पाद नहीं जोड़ा गया',
    pleaseAddAtLeastOneProduct: 'कृपया कम से कम एक उत्पाद जोड़ें',
    invoiceCreatedSuccessfully: 'चालान सफलतापूर्वक बनाया गया',
    success: 'सफलता',
    productNotSelected: 'उत्पाद नहीं चुना गया',
    pleaseSelectAProduct: 'कृपया एक उत्पाद चुनें',
    alreadyAdded: 'पहले से ही जोड़ा',
    productAlreadyAdded: 'उत्पाद पहले ही जोड़ा जा चुका है',
    productRequired: 'उत्पाद की आवश्यकता',
    pleaseAddProducts: 'कृपया उत्पाद जोड़ें',
    noFilesSelected: 'कोई फ़ाइल नहीं चुनी गई',
    invoiceDetails: 'इनवॉइस विवरण',
    invoiceNumber: 'इनवॉइस संख्या',
    invoiceDate: 'इनवॉइस दिनांक',
    invoice: 'इनवॉइस',
    download: 'डाउनलोड',
    files: 'फ़ाइलें',
    metricTonsAvailable: 'मीट्रिक-टन उपलब्ध',
    invoiceId: 'इनवॉइस पहचान',
    priceIn: 'मूल्य (आईएनआर के साथ जीएसटी)',
    pleaseEnterInvoiceNumber: 'कृपया चालान संख्या दर्ज करें',
    pleaseUploadAnInvoiceFile: 'कृपया चालान फ़ाइल अपलोड करें',
    invoiceVerify:
      'मैं यह सत्यापित करता हूं कि यह बिल विवरण सत्य और सही है और मैं इसे पहली बार क्रेडिट के लिए यहां अंकित कर रहा हूं।',
    pleaseConfirmInvoiceDetailsByClickingCheckbox:
      'कृपया चेक बॉक्स पर क्लिक करके चालान विवरण की पुष्टि करें',
    edit: {
      edit: 'चालान संपाद',
      details: 'चालान विवरण संपाद',
    },
  },
  profile: {
    myProfile: 'मेरी प्रोफाइल',
    changeCredentials: 'पासवर्ड बदलें',
    changePasswordUsingPhoneNumber: 'फ़ोन नंबर का उपयोग करके पासवर्ड बदलें',
    changePassword: 'पासवर्ड बदलें',
    supportfeedback: 'समर्थन और प्रतिक्रिया',
    uploadFiles: 'फाइल अपलोड करें',
    idProofType: 'आईडी प्रूफ टाइप',
    uploadIdProof: 'आईडी प्रूफ अपलोड करें',
    uploadPhoto: 'फोटो अपलोड करें',
    settings: 'सेटिंग्स',
    logout: 'लॉग आउट',
    companyDetails: 'फर्म का विवरण',
    dealershipCompanies: 'सीमेंट ब्रांड जिसमें आप डील करते है',
    dealerPlaceHolder: 'कृपया डीलरशिप कम्पनियाँ चुनें',
    addCompany: 'कंपनी जोड़ें',
    addEmployee: 'अपने मैनेजर/अकाउंटेंट को जोड़ें',
    employee: 'कर्मचारी',
    editProfile: 'प्रोफ़ाइल अपडेट करें',
    changeLanguage: 'भाषा चुनें',
    aadharCard: 'आधार कार्ड',
    aadharNo: 'आधार संख्‍या',
    panCard: 'पैन कार्ड',
    gstin: 'जी यस टी सर्टिफिकेट',
    faq: 'आम प्रश्नों के उत्तर',
    contactUs: 'संपर्क करें',
    deleteAccount: 'खाता हटा दो',
    changePhoneNumber: 'फ़ोन नंबर बदलें',
  },
  addProduct: {
    pleaseenterquantity: 'कृपया मात्रा दर्ज करें',
    pleaseselectproduct: 'कृपया उत्पाद चुनें',
    pleaseselectretailer: 'कृपया खुदरा विक्रेता का चयन करें',
    searchproduct: 'उत्पाद खोजें',
    atprice: 'कीमत पर',
    quantity: 'मात्रा',
    addretailer: 'खुदरा विक्रेता जोड़ें',
    retailer: 'खुदरा विक्रेता',
    additem: 'वस्तु जोड़ें',
    delivertoself: 'खुद को भेजें',
    itemadded: 'वस्तु जोड़ा गया',
    itemsadded: 'वस्तुएँ जोड़े गए',
    continue: 'जारी रखें',
    wasaddedwithquantity: 'मात्रा के साथ जोड़ा गया',
    additemtocontinue: 'जारी रखने के लिए आइटम जोड़ें',
    pleaseAddProductInInventoryToSell:
      'कृपया उत्पाद को बेचने के लिए सूची में जोड़ें',
  },
  checkout: {
    productsadded: 'उत्पाद जोड़े गए',
    viewallorders: 'सभी ऑर्डर देखें',
    totalvalue: 'कुल मूल्य',
    ordernow: 'अभी ऑर्डर करें',
    retailerformcannotbeempty: 'खुदरा फॉर्म खाली नहीं हो सकता',
    quantitycannotbelessthanretailersquantity:
      'मात्रा खुदरा की मात्रा से कम नहीं हो सकता',
    atprice: 'कीमत पर',
    delivertoself: 'खुद को भेजें',
    addretailer: 'खुदरा विक्रेता जोड़ें',
    retailer: 'खुदरा विक्रेता',
    quantity: 'मात्रा',
    update: 'अद्यतन',
    retrypayment: 'पैसे पुनः प्रयास करें',
    yourorderwasplaced: 'आपका ऑर्डर दिया गया था',
    successfully: 'सफलतापूर्वक',
    ordernumber: 'ऑर्डर संख्या',
    orderPayment: 'ऑर्डर भुगतान',
  },
  orderDetails: {
    invoiceuploadedsuccessfully: 'चालान सफलतापूर्वक अपलोड किया गया',
    retailer: 'खुदरा',
    quantity: 'मात्रा',
    address: 'पता',
    product: 'उत्पाद',
    price: 'कीमत',
    orderdetails: 'ऑर्डर विवरण',
    pleaseenterinvoicenumber: 'कृपया चालान नंबर दर्ज करें',
    adddeliveryinfo: 'डिलीवरी जानकारी जोड़ें',
    uploadorderinvoice: 'ऑर्डर चालान अपलोड करें',
    submit: 'सबमिट करें',
    retailername: 'खुदरा का नाम',
    invoicenumber: 'चालान नंबर',
    status: 'स्टेटस',
    orderdeliverycompleted: 'ऑर्डर डिलीवरी पूर्ण',
  },
  order: {
    doyouwanttochangecompany: 'क्या आप कंपनी बदलना चाहते हैं?',
    changingthecompanywillcleartheitemsaddedtothecart:
      'कंपनी बदलना के लिए कार्ट में जोड़े गए वस्तुएँ खाली कर दिया जाएगा:',
    ordernow: 'अभी ऑर्डर करें',
    continue: 'जारी रखें',
  },
  viewOrder: {
    orderid: 'ऑर्डर आईडी',
    retrypaymentforthisorder: 'इस ऑर्डर के लिए पैसे पुनः प्रयास करें',
    yes: 'हाँ',
    no: 'नहीं',
    ordernow: 'अभी ऑर्डर करें',
    myorders: 'मेरे ऑर्डर',
    placeOrder: 'स्थान ऑर्डर',
    xfactoryPrice: 'एक्स फैक्टरी मूल्य',
    loadingCharges: 'लदान शुल्क',
    addToCart: 'कार्ट में जोड़ें',
  },
  orderStatus: {
    INITIATED: 'आरम्भ',
    PAYMENTCOMPLETED: 'पैसे पूर्ण',
    PAYMENTFAILED: 'पैसे असफल',
    DELIVERED: 'डिलीवरी',
    FAILED: 'असफल',
    SUCCESS: 'सफल',
    PENDING: 'लंबित',
    DISPATCHED: 'प्रेषित',
    PAYMENTSENDTOSELLER: 'विक्रेता को पैसे भेजा जाना चाहिए',
    PARTIALPAYMENTDONE: 'आधारित पैसे पूर्ण',
    PARTIALLYDELIVERED: 'आधारित डिलीवरी',
  },
  userType: {
    MASON: 'शिल्पकार',
    DISTRIBUTOR: 'डीलर',
    DEALER_RETAILER: 'डीलर + रिटेलर',
    RETAILER: 'रिटेलर',
    CEMENT_COMPANY: 'सीमेंट कंपनी',
    HUMBEE_SUPPORT: 'हम्बी समर्थन',
    PROJECT: 'परियोजना',
    ASSOCIATE: 'एसोसिएट',

    BARBENDER: 'शिल्पकार/बार बेंडर',
    ENGINEER: 'इंजीनियर',
    BAR_BENDER: 'CONTACTOR',
    ARCHITECH: 'आर्किटेक्ट',
    PAINTER: 'PAINTER',
    FABRICATOR: 'FABRICATOR',
  },
  inventory: {
    brand: 'ब्रांड',
  },
  sellToBuyer: {
    sell: 'बेचें',
    sellItem: 'सामान बेचें',
    sellToMason: 'शिल्पकार को बिक्री',
    sellToProject: 'प्रोजेक्ट को बेचें',
    sellToAssociate: 'सहयोगी को बेचें',
    sellToRetailer: 'रिटेलर को बिक्री ',
  },
  notifications: {
    isRequired: 'आवश्यक है',
    pleaseEnter: 'कृपया दर्ज करें',
    success: 'सफल',
    succesfullyRemoved: 'सफलतापूर्वक हटा दिया गया',
    succesfullyAdded: 'सफलतापूर्वक जोड़ा गया',
    invalid: 'अमान्य',
    fileType: 'फाइल का प्रकार',
    fileTypeMessage: 'केवल पीडीएफ या चित्र स्वीकार किए जाते हैं',
    missingFileMessage: 'कृपया पहले एक फ़ाइल प्रकार चुनें',
    missingPhoneNumber: 'जारी रखने के लिए कृपया फ़ोन नंबर दर्ज करें',
    maxQuantMess: 'अधिकतम मात्रा पार हो गई',
    alreadyRegisterdMsg: 'नंबर पहले से पंजीकृत है',
  },
  qtunits: {
    bag: 'बैग',
    metricTons: 'ऍम टी',
    kg: 'किलोग्राम',
  },
};
